// extracted by mini-css-extract-plugin
export default {"main-container":"DiscoverLists_main-container__HUQGo"};